import { render, staticRenderFns } from "./PremisesClasses.vue?vue&type=template&id=056e3e98"
import script from "./PremisesClasses.vue?vue&type=script&lang=js"
export * from "./PremisesClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports